import { IconFont, Tooltip } from '@byecode/ui'
import { useCurrentEditor } from '@tiptap/react'
import type { FC } from 'react'
import React from 'react'

import { useLanguageContext } from '../../../contexts'
import { CustomActionIcon } from './styles'

export const EraserMenu: FC = () => {
    const { editor } = useCurrentEditor()
    const { convertTextByLanguage } = useLanguageContext()

    return (
        <Tooltip title={convertTextByLanguage('clearFormat')}>
            <CustomActionIcon
                variant="subtle"
                onClick={() => {
                    if (editor?.state.selection.empty) {
                        return
                    }
                    editor?.chain().focus().unsetTextAlign().unsetAllMarks().run()
                }}
            >
                <IconFont
                    type="Eraser"
                    color={editor?.state.selection.empty ? 'var(--color-gray-400)' : undefined}
                    style={{ cursor: editor?.state.selection.empty ? 'not-allowed' : undefined }}
                />
            </CustomActionIcon>
        </Tooltip>
    )
}
